import * as React from 'react';

import VideoCamera from '../VideoCamera';
import CircularGradient, { CircularGradientProps } from './CircularGradient';

export interface CircularGradientVideoCameraAltProps
  extends Pick<CircularGradientProps, 'className'> {
  iconClassName?: string;
}

const CircularGradientVideoCameraAlt: React.FC<CircularGradientVideoCameraAltProps> = ({
  className,
  iconClassName,
}) => (
  <CircularGradient className={className}>
    <VideoCamera
      className={iconClassName}
      strokeWidth={1}
      style={{
        height: 'auto',
        marginLeft: '8%',
        width: '45%',
      }}
    />
  </CircularGradient>
);

export default CircularGradientVideoCameraAlt;
